import { render, staticRenderFns } from "./AiCallingSettings.vue?vue&type=template&id=449708c3&scoped=true&"
import script from "./AiCallingSettings.vue?vue&type=script&lang=js&"
export * from "./AiCallingSettings.vue?vue&type=script&lang=js&"
import style0 from "./AiCallingSettings.vue?vue&type=style&index=0&id=449708c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449708c3",
  null
  
)

export default component.exports